module.exports = __webpack_public_path__ + "static/media/thunder.065cee75.svg";